module.exports = __webpack_public_path__ + "static/media/ball_1_3.0c26c72a.mp3";